export default __webpack_public_path__ + "static/media/am.1069b478.jpg";